import { CHANGE_PASSWORD, GET_ACTIVE_TOKEN, GET_EMPLEADORES, LOGIN, LOGOUT } from "../actions/auth";

const INITIAL_STATE = {
  authenticated: false,
  loading: false,
  error: false,
  data: {},
  activeToken: {
    loading: false,
    error: false,
    data: {},
  },
  empleadores: {
    loading: false,
    error: false,
    data: [],
  },
  changePassword: {
    loading: false,
    error: false,
    data: [],
  }
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${LOGIN}_PENDING`:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case `${LOGIN}_REJECTED`:
      return {
        ...state,
        loading: false,
        error: true,
        authenticated: action?.meta?.asEmpleador,
      };
    case `${LOGIN}_FULFILLED`:
      return {
        ...state,
        error: false,
        loading: false,
        authenticated: true,
        data: action.payload.data,
      };
    case `${GET_ACTIVE_TOKEN}_PENDING`:
      return {
        ...state,
        activeToken: { ...state.activeToken, error: false, loading: true },
      };
    case `${GET_ACTIVE_TOKEN}_REJECTED`:
      return {
        ...state,
        activeToken: { ...state.activeToken, error: true, loading: false },
      };
    case `${GET_ACTIVE_TOKEN}_FULFILLED`:
      return {
        ...state,
        activeToken: {
          ...state.activeToken,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_EMPLEADORES}_PENDING`:
      return {
        ...state,
        empleadores: {
          ...state.empleadores,
          loading: true,
          error: false,
        },
      };
    case `${GET_EMPLEADORES}_REJECTED`:
      return {
        ...state,
        empleadores: {
          ...state.empleadores,
          loading: false,
          error: true,
        },
      };
    case `${GET_EMPLEADORES}_FULFILLED`:
      return {
        ...state,
        empleadores: {
          loading: false,
          error: false,
          data: action.payload.data,
        },
      };

    case `${CHANGE_PASSWORD}_PENDING`:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: true,
          error: false,
        },
      };
    case `${CHANGE_PASSWORD}_REJECTED`:
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          loading: false,
          error: true,
        },
      };
    case `${CHANGE_PASSWORD}_FULFILLED`:
      return {
        ...state,
        changePassword: {
          loading: false,
          error: false,
          data: action.payload.data,
        },
      };


    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default auth;
